import { render, staticRenderFns } from "./BusquedaEnFecha.vue?vue&type=template&id=36245ab8&"
import script from "./BusquedaEnFecha.vue?vue&type=script&lang=js&"
export * from "./BusquedaEnFecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports